export const PAYMENT_FORMS = ["cash", "card", "paid"] as const

export const ORDER_ALLOWED_STATES = [
  "waiting",
  "pending",
  "assigned",
  "published",
  "started",
  "finished",
  "canceled",
  "failed",
] as const

export const ORDER_STATES = ["draft", "unpaid", ...ORDER_ALLOWED_STATES, "expired"] as const

export const ORDER_POINT_ALLOWED_STATES = [
  "pending",
  "assigned",
  "published",
  "started",
  "in_progress",
  "finished",
  "canceled",
  "failed",
] as const

export const ORDER_POINT_STATES = [...ORDER_POINT_ALLOWED_STATES, "expired"] as const

export const ADDITIONAL_FEES_TYPES = ["delay", "package_size", "other"] as const

export const TRANSPORT_TYPES = ["car", "bicycle", "scooter"] as const

export const DELIGOO_PACKAGE_TYPES = ["big-pizza", "standard-dish", "own-packaging"] as const
export const HEBE_PACKAGE_TYPES = ["hebe-box-1", "hebe-box-2", "hebe-box-3", "hebe-box-4", "hebe-box-5"] as const
export const ECOMMERCE_PACKAGE_TYPES = ["ecommerce-size-a", "ecommerce-size-b", "ecommerce-size-c"] as const
export const INPOST_PACKAGE_TYPES = ["inpost-size-a", "inpost-size-b", "inpost-size-c"] as const
